module.exports = __webpack_public_path__ + "img/icon-search.47bd182c.svg";